"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./membership-types"));
__export(require("./firm-billing-types"));
__export(require("./b2b-membership-types-tiers"));
__export(require("./bridge-types"));
const __1 = require("..");
var UserErrorCodes;
(function (UserErrorCodes) {
    UserErrorCodes["E0000001"] = "E0000001";
    UserErrorCodes["E0000004"] = "E0000004";
    UserErrorCodes["LOGIN_NOT_FOUND"] = "LOGIN_NOT_FOUND";
    UserErrorCodes["LOCKED_OUT"] = "LOCKED_OUT";
    UserErrorCodes["DEPROVISIONED"] = "DEPROVISIONED";
    UserErrorCodes["USER_ALREADY_EXISTS"] = "USER_ALREADY_EXISTS";
    UserErrorCodes["RESET_PASS_TOKEN_EXPIRED"] = "RESET_PASS_TOKEN_EXPIRED";
    UserErrorCodes["RESET_PASS_TOKEN_INCORRECT"] = "RESET_PASS_TOKEN_INCORRECT";
    UserErrorCodes["RESET_PASS_PREVIOUSLY_USED"] = "RESET_PASS_PREVIOUSLY_USED";
    UserErrorCodes["RESET_PASS_CURRENT_USED"] = "RESET_PASS_CURRENT_USED";
    UserErrorCodes["INCORRECT_PASSWORD"] = "INCORRECT_PASSWORD";
    UserErrorCodes["WEAK_PASSWORD_PATTERN"] = "WEAK_PASSWORD_PATTERN";
    UserErrorCodes["REGISTRATION_ERROR"] = "REGISTRATION_ERROR";
    UserErrorCodes["CONTACT_PREFERENCES_ERROR"] = "CONTACT_PREFERENCES_ERROR";
    UserErrorCodes["PASSWORD_EXPIRED"] = "PASSWORD_EXPIRED";
    UserErrorCodes["RECOVERY"] = "RECOVERY";
    UserErrorCodes["DATA_NOT_YET_MIGRATED"] = "DATA_NOT_YET_MIGRATED";
})(UserErrorCodes = exports.UserErrorCodes || (exports.UserErrorCodes = {}));
var UserPlatform;
(function (UserPlatform) {
    UserPlatform["NOT_FOUND"] = "NOT_FOUND";
    UserPlatform["RAVE"] = "RAVE";
    UserPlatform["LEGACY"] = "LEGACY";
})(UserPlatform = exports.UserPlatform || (exports.UserPlatform = {}));
var MembershipApplicationStages;
(function (MembershipApplicationStages) {
    MembershipApplicationStages["PRE_SIGN_UP"] = "pre-sign-up";
    MembershipApplicationStages["PACKAGE_BUILDER"] = "package";
    MembershipApplicationStages["APPLICATION"] = "application";
    MembershipApplicationStages["START"] = "start";
    MembershipApplicationStages["PERSONAL"] = "personal";
    MembershipApplicationStages["QUALIFICATION"] = "qualification";
    MembershipApplicationStages["CPA"] = "cpa";
    MembershipApplicationStages["EMPLOYMENT"] = "employment";
    MembershipApplicationStages["TRAINING"] = "training";
    MembershipApplicationStages["DOCUMENT"] = "document";
    MembershipApplicationStages["DOCUMENT_GATEWAY"] = "gateway";
    MembershipApplicationStages["DONATION"] = "donation";
    MembershipApplicationStages["ATTESTATION"] = "attestation";
    MembershipApplicationStages["CREDENTIALS"] = "credentials";
    MembershipApplicationStages["ADDRESS"] = "address";
    MembershipApplicationStages["SUMMARY"] = "summary";
    // CenterMembership Application Stages
    MembershipApplicationStages["ADMIN"] = "admin";
    MembershipApplicationStages["ORGANIZATION"] = "organization";
    MembershipApplicationStages["PAYMENT"] = "payment";
})(MembershipApplicationStages = exports.MembershipApplicationStages || (exports.MembershipApplicationStages = {}));
var RegistrationActions;
(function (RegistrationActions) {
    RegistrationActions["CENTERS_ADMIN_REGISTRATION"] = "centers-admin-registration";
})(RegistrationActions = exports.RegistrationActions || (exports.RegistrationActions = {}));
var ProvisioningTypes;
(function (ProvisioningTypes) {
    ProvisioningTypes[ProvisioningTypes["B2B"] = 0] = "B2B";
    ProvisioningTypes[ProvisioningTypes["CENTER_MEMBERSHIP"] = 1] = "CENTER_MEMBERSHIP";
})(ProvisioningTypes = exports.ProvisioningTypes || (exports.ProvisioningTypes = {}));
var FirmMembershipCancellationActions;
(function (FirmMembershipCancellationActions) {
    FirmMembershipCancellationActions["TERMINATE"] = "TERMINATE";
    FirmMembershipCancellationActions["RESIGN_NO_REFUND"] = "RESIGN_NO_REFUND";
    FirmMembershipCancellationActions["RESIGN_AND_REFUND"] = "RESIGN_AND_REFUND";
})(FirmMembershipCancellationActions = exports.FirmMembershipCancellationActions || (exports.FirmMembershipCancellationActions = {}));
var CertificateStatus;
(function (CertificateStatus) {
    CertificateStatus["Issued"] = "Issued by the Association";
    CertificateStatus["Submitted"] = "Submitted to external body";
    CertificateStatus["Pending"] = "Pending";
})(CertificateStatus = exports.CertificateStatus || (exports.CertificateStatus = {}));
var QualificationLevelStatus;
(function (QualificationLevelStatus) {
    QualificationLevelStatus["Active"] = "Active";
    QualificationLevelStatus["Exempted"] = "Exempted";
    QualificationLevelStatus["Completed"] = "Completed";
    QualificationLevelStatus["Locked"] = "Locked";
    QualificationLevelStatus["Suspended"] = "Suspended";
    QualificationLevelStatus["NotApplicable"] = "Not Applicable";
    QualificationLevelStatus["PendingProgressionEngineRun"] = "Pending - Progression engine run";
    QualificationLevelStatus["PendingTPConfirmation"] = "Pending - TP confirmation";
})(QualificationLevelStatus = exports.QualificationLevelStatus || (exports.QualificationLevelStatus = {}));
var ExemptionLevelStatus;
(function (ExemptionLevelStatus) {
    ExemptionLevelStatus["Pending"] = "Draft";
    ExemptionLevelStatus["Completed"] = "Submitted";
})(ExemptionLevelStatus = exports.ExemptionLevelStatus || (exports.ExemptionLevelStatus = {}));
var GatewayStatus;
(function (GatewayStatus) {
    GatewayStatus["Pending"] = "Pending";
    GatewayStatus["Passed"] = "Passed";
})(GatewayStatus = exports.GatewayStatus || (exports.GatewayStatus = {}));
var GatewayDocumentStatus;
(function (GatewayDocumentStatus) {
    GatewayDocumentStatus["Draft"] = "Draft";
    GatewayDocumentStatus["Submitted"] = "Submitted";
})(GatewayDocumentStatus = exports.GatewayDocumentStatus || (exports.GatewayDocumentStatus = {}));
var SubjectBlockStatus;
(function (SubjectBlockStatus) {
    SubjectBlockStatus["Exempted"] = "Exempted";
    SubjectBlockStatus["Locked"] = "Locked";
    SubjectBlockStatus["Booked"] = "Booked";
    SubjectBlockStatus["Bookable"] = "Bookable";
    SubjectBlockStatus["Completed"] = "Completed";
    SubjectBlockStatus["Waived"] = "Waived";
    SubjectBlockStatus["Active"] = "Active";
    SubjectBlockStatus["Failed"] = "Failed";
    SubjectBlockStatus["NotApplicable"] = "NotApplicable";
})(SubjectBlockStatus = exports.SubjectBlockStatus || (exports.SubjectBlockStatus = {}));
var ResultStatus;
(function (ResultStatus) {
    ResultStatus["Pending"] = "Results pending";
    ResultStatus["Complete"] = "Complete";
    ResultStatus["InProgress"] = "In Progress";
    ResultStatus["Failed"] = "Failed";
})(ResultStatus = exports.ResultStatus || (exports.ResultStatus = {}));
var ExamDeliveryFormat;
(function (ExamDeliveryFormat) {
    ExamDeliveryFormat["All"] = "All";
    ExamDeliveryFormat["OnlineExam"] = "Online";
    ExamDeliveryFormat["TestCenter"] = "In Centre";
})(ExamDeliveryFormat = exports.ExamDeliveryFormat || (exports.ExamDeliveryFormat = {}));
var SubjectBlockType;
(function (SubjectBlockType) {
    SubjectBlockType["ObjectiveTest"] = "Objective Test";
    SubjectBlockType["CaseStudy"] = "Case Study";
    SubjectBlockType["FLP"] = "FLP Competency";
    SubjectBlockType["ApprenticeEPA"] = "Apprentice - End Point Assessment";
})(SubjectBlockType = exports.SubjectBlockType || (exports.SubjectBlockType = {}));
var RatificationStatus;
(function (RatificationStatus) {
    RatificationStatus["RATIFIED"] = "Ratified";
    RatificationStatus["PENDING_RATIFICATION"] = "Pending Ratification";
})(RatificationStatus = exports.RatificationStatus || (exports.RatificationStatus = {}));
var EmployerSelectionUseCaseEnum;
(function (EmployerSelectionUseCaseEnum) {
    EmployerSelectionUseCaseEnum["SEARCH_TO_CONNECTED_EMPLOYERS"] = "SEARCH_TO_CONNECTED_EMPLOYERS";
    EmployerSelectionUseCaseEnum["SEARCH_TO_SALESFORCE_ZOOMINFO"] = "SEARCH_TO_SALESFORCE_ZOOMINFO";
    EmployerSelectionUseCaseEnum["CREATE_MANUALLY"] = "CREATE_MANUALLY";
})(EmployerSelectionUseCaseEnum = exports.EmployerSelectionUseCaseEnum || (exports.EmployerSelectionUseCaseEnum = {}));
var StudentExamResultStatus;
(function (StudentExamResultStatus) {
    StudentExamResultStatus["PASS"] = "Pass";
    StudentExamResultStatus["PASS_DISTINCTION"] = "Pass with distinction";
    StudentExamResultStatus["FAIL"] = "Fail";
    StudentExamResultStatus["NO_SHOW"] = "No Show";
    StudentExamResultStatus["ERROR"] = "Error";
    StudentExamResultStatus["NDA_REFUSED"] = "NDA Refused";
})(StudentExamResultStatus = exports.StudentExamResultStatus || (exports.StudentExamResultStatus = {}));
var StudentExamProficiencyLevels;
(function (StudentExamProficiencyLevels) {
    StudentExamProficiencyLevels["PASS"] = "Pass";
    StudentExamProficiencyLevels["FAIL"] = "Fail";
    StudentExamProficiencyLevels["NOT_PROFICIENT_LC"] = "Not proficient";
    StudentExamProficiencyLevels["NOT_PROFICIENT"] = "Not Proficient";
    StudentExamProficiencyLevels["NON_PROFICIENT"] = "Non-Proficient";
    StudentExamProficiencyLevels["PROFICIENT"] = "Proficient";
    StudentExamProficiencyLevels["DISTINCTION"] = "Distinction";
})(StudentExamProficiencyLevels = exports.StudentExamProficiencyLevels || (exports.StudentExamProficiencyLevels = {}));
var SessionType;
(function (SessionType) {
    SessionType["NO_SESSION"] = "noSession";
    SessionType["EXTERNAL_SESSION"] = "externalSession";
    SessionType["OKTA_SESSION"] = "oktaSession";
})(SessionType = exports.SessionType || (exports.SessionType = {}));
var OktaStatus;
(function (OktaStatus) {
    OktaStatus["ACTIVE"] = "ACTIVE";
    OktaStatus["PROVISIONED"] = "PROVISIONED";
    OktaStatus["STAGED"] = "STAGED";
    OktaStatus["RECOVERY"] = "RECOVERY";
    OktaStatus["PASSWORD_EXPIRED"] = "PASSWORD_EXPIRED";
    OktaStatus["LOCKED_OUT"] = "LOCKED_OUT";
    OktaStatus["SUSPENDED"] = "SUSPENDED";
    OktaStatus["DEPROVISIONED"] = "DEPROVISIONED";
})(OktaStatus = exports.OktaStatus || (exports.OktaStatus = {}));
var ProfessionalStatus;
(function (ProfessionalStatus) {
    ProfessionalStatus["STUDENT"] = "Student";
    ProfessionalStatus["EMPLOYED"] = "Employed";
    ProfessionalStatus["NOT_WORKING"] = "Not Working";
    ProfessionalStatus["EMPLOYED_AND_STUDENT"] = "Employed and Student";
})(ProfessionalStatus = exports.ProfessionalStatus || (exports.ProfessionalStatus = {}));
var ExamResultsEmailNotification;
(function (ExamResultsEmailNotification) {
    ExamResultsEmailNotification["ON"] = "On";
    ExamResultsEmailNotification["OFF"] = "Off";
    ExamResultsEmailNotification["NONE"] = "None";
})(ExamResultsEmailNotification = exports.ExamResultsEmailNotification || (exports.ExamResultsEmailNotification = {}));
exports.SalutationOptionList = [
    { key: 1, value: 'Mr.', text: 'Mr.' },
    { key: 2, value: 'Mrs.', text: 'Mrs.' },
    { key: 3, value: 'Miss.', text: 'Miss.' },
    { key: 4, value: 'Sir.', text: 'Sir.' },
    { key: 5, value: 'Dr.', text: 'Dr.' },
];
//# sourceMappingURL=index.js.map